import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'dorm moving storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'dorm moving storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Fast <span>Dorm Moving</span><span>Storage Solutions</span>',
  description:
    'Streamline your college move with reliable and affordable dorm moving storage services, including flexible storage options, free insurance, and free storage for up to 6 months.',
  image: {
    url: '/images/v2/pages/landing-pages/dorm-moving-storage/hero-image.jpg',
    alt: 'Fast Dorm Moving Storage Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Dorm Moving Services' }
}

export const ourProcessSectionContent = {
  title: 'How We Ensure Fast U-Box Storage Services',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Schedule Your Pickup' },

  image: {
    url: '/images/v2/pages/landing-pages/dorm-moving-storage/how-we-ensure-fast-u-box-storage-services.png',
    alt: 'How We Ensure Fast U-Box Storage Services'
  },

  articles: [
    {
      id: 1,
      title: 'Flat-Rate Pricing',
      description:
        'We offer transparent and competitive pricing designed specifically for students’ budgets, ensuring cost-effective solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/flat-rate-pricing.png',
        alt: 'Flat-Rate Pricing'
      }
    },
    {
      id: 2,
      title: 'Free Pickup and Delivery',
      description: 'Our complimentary pickup and delivery services make dorm moving storage seamless and hassle-free.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/free-pickup-and-delivery.png',
        alt: 'Free Pickup and Delivery'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Plans',
      description:
        'Choose short-term or long-term options tailored to meet your dorm moving storage needs without any stress',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/flexible-storage-plans.png',
        alt: 'Flexible Storage Plans'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast Dorm Moving Storage Services',
  description:
    'We provide quick and efficient dorm moving storage solutions to meet your deadlines. With professional handling and timely service, your move-in or move-out becomes seamless and stress-free.',
  image: {
    src: '/images/v2/pages/landing-pages/dorm-moving-storage/fast-dorm-moving-storage-services.jpg',
    alt: 'Fast Dorm Moving Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Dorm Moving Services',

  cards: [
    {
      id: 1,
      title: 'Stress-Free Logistics',
      description: 'Simplify your move with our reliable door-to-door pickup and delivery services',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/stress-free-logistics.png',
        alt: 'Stress-Free Logistics'
      }
    },
    {
      id: 2,
      title: 'Budget-Friendly Solutions',
      description: 'Affordable plans crafted to fit student budgets without compromising on quality',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/budget-friendly-solutions.png',
        alt: 'Budget-Friendly Solutions'
      }
    },
    {
      id: 3,
      title: 'Secure Storage Options',
      description:
        'Our climate-controlled, ensured storage facilities keep your belongings safe and in pristine condition.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/secure-storage-options.png',
        alt: 'Secure Storage Options'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Dorm Moving Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          description: 'Students transitioning between dorms or campuses.'
        },
        {
          id: 2,
          description: 'Parents looking for a convenient way to store their child’s belongings during summer breaks.'
        },
        {
          id: 3,
          description: 'International scholars needing affordable, secure storage options.'
        },
        {
          id: 4,
          description: 'Anyone seeking reliable dorm moving storage solutions.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/who-should-choose-us-for-dorm-moving-services.jpg',
        alt: 'Who Should Choose Us for Dorm Moving Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description: 'Secure and flexible storage options for business equipment, files, and inventory management.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Short-term or long-term storage services to simplify relocations for any size move.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Affordable worldwide shipping for students, travelers, and anyone moving belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Flexible and secure storage solutions for seasonal or transitional residential needs.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-moving-storage/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Dorm Moving Services',

  image: {
    url: '/images/v2/pages/landing-pages/dorm-moving-storage/why-choose-shipandstorage-for-dorm-moving-services.jpg',
    alt: 'Why Choose ShipAndStorage for Dorm Moving Services'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Pricing',
      description: 'Tailored pricing plans designed to fit student budgets without breaking the bank'
    },
    {
      id: 2,
      title: 'Expert Handling',
      description: 'Trust our experienced team to handle your belongings safely and efficiently'
    },
    {
      id: 3,
      title: 'Free Insurance',
      description: 'Get up to $250 in insurance coverage for added peace of mind'
    },
    {
      id: 4,
      title: 'Convenient Pickup/Delivery',
      description: 'Enjoy door-to-door service at your convenience, eliminating the stress of logistics'
    },
    {
      id: 5,
      title: 'Flexible Plans',
      description: 'Customize your storage options based on the number of items and storage duration'
    },
    {
      id: 6,
      title: 'Secure Facilities',
      description:
        'Climate-controlled and monitored storage facilities ensure the safety and protection of your belongings'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast Dorm Moving and Storage Services Available',
  description:
    'Fast, affordable dorm moving storage solutions available. Secure, reliable services for storing and moving your dorm room belongings quickly',
  image: {
    src: '/images/v2/pages/landing-pages/dorm-moving-storage/fast-dorm-moving-and-storage-services-available.png',
    alt: 'Fast Dorm Moving and Storage Services Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Secure Your Space' }
}

export const ourPartnersSectionContent = {
  description:
    'At ShipAndStorage, we are proud to partner with leading global carriers such as FedEx, DHL, and UPS to deliver exceptional shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Founded in 1971 by Frederick W. Smith, FedEx began its journey with just 186 packages and has since evolved into a global shipping powerhouse. Today, FedEx operates a fleet of 696 aircraft and 215,000 vehicles, managing around 16 million shipments daily across more than 220 countries and territories. With a dedicated workforce of over 550,000 employees and 5,000 locations worldwide, FedEx is committed to providing reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a core division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a logistics leader, DHL manages over 1.8 billion parcels annually. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in over 220 countries, playing a vital role in the global supply chain.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Originally established as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS is one of the largest shipping companies in the world, delivering approximately 25 million packages daily. With a workforce of over 500,000 employees globally, UPS serves more than 220 countries and territories, providing unmatched global reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
